import { StratusStatsCardTeamTemplateModel } from "./StratusStatsCardTeamTemplateModel";
import { StratusStatsCardPlayerTemplateModel } from "./StratusStatsCardPlayerTemplateModel";

export class StratusStatsCardComponentTemplateModel {
    type: number;
    topEntityCount: number;
    showStartingNumber: boolean;
    showFullMetricName: boolean;
    showExportToCSV: boolean;
    baseColor: string;
    secondaryColor: string;
    heading: string;
    highlightRule: number;
    highlightTextColor: string;
    seriesName: string;
    seasonName: string;
    homeTeam: StratusStatsCardTeamTemplateModel;
    awayTeam: StratusStatsCardTeamTemplateModel;
    homeTeamPlayers: StratusStatsCardPlayerTemplateModel[];
    awayTeamPlayers: StratusStatsCardPlayerTemplateModel[];
    teams: StratusStatsCardTeamTemplateModel[];
    players: StratusStatsCardPlayerTemplateModel[];

    constructor(type, baseColor, secondaryColor, heading, highlightRule, highlightTextColor, topEntityAmount, showStartingNumber, showFullMetricName, showExportToCSV) {
        this.type = type;
        this.baseColor = baseColor;
        this.secondaryColor = secondaryColor;
        this.heading = heading;
        this.highlightRule = highlightRule;
        this.highlightTextColor = highlightTextColor;
        this.topEntityCount = topEntityAmount;
        this.showStartingNumber = showStartingNumber;
        this.showFullMetricName = showFullMetricName;
        this.showExportToCSV = showExportToCSV;

        this.homeTeamPlayers = [];
        this.awayTeamPlayers = [];
        this.teams = [];
        this.players = [];
    }
}